import React from 'react';

import { useIsPlayerStarted } from '@/scenarios/legacy-player/hooks/useIsPlayerStarted';

import { useToggleOnAirWithIndicator } from '../../../hooks/skin/use-toggle-on-air-with-indicator';

import { LiveOnAirControlComponent } from './component';
import { useIsOnAir } from './hooks/use-is-on-air';

interface Props {
    className?: string;
}

export const LiveOnAirControl = ({ className }: Props) => {
    const isOnAir = useIsOnAir();
    const { returnToAir } = useToggleOnAirWithIndicator();
    const isStarted = useIsPlayerStarted();

    return (
        <LiveOnAirControlComponent
            isOnAir={isOnAir}
            className={className}
            onClick={returnToAir}
            isStarted={isStarted}
        />
    );
};
